import { useEffect, useState } from "react";
import { Textarea } from "../ui/textarea";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from "../ui/dialog";

export const NotesDialog = ({ lead, onClose, onSave }) => {
  const [draft, setDraft] = useState("");

  useEffect(() => {
    if (lead) setDraft(lead.notes || "");
  }, [lead, setDraft]);

  return (
    <Dialog open={!!lead} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#121212] border-zinc-800 text-white">
        <DialogHeader>
          <DialogTitle className="font-heading">Notes — {lead?.name}</DialogTitle>
          <DialogDescription className="text-zinc-500">
            Private notes for this lead. Only visible to you.
          </DialogDescription>
        </DialogHeader>
        <Textarea
          data-testid="notes-textarea"
          className="bg-[#0a0a0a] border-zinc-800 text-white h-36 rounded-sm"
          placeholder="Internal notes about this lead..."
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
        />
        <DialogFooter>
          <button
            data-testid="notes-save-button"
            onClick={() => onSave(draft)}
            className="bg-blue-600 hover:bg-blue-700 text-white rounded-sm px-6 py-2.5 text-sm font-semibold transition-colors"
          >
            Save Notes
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
